{
    "Rules_Validation_MustBeANumber": "Muss eine Zahl sein",
    "Rules_Validation_MustBeAnInteger": "Muss eine ganze Zahl sein",
    "Rules_Validation_MustBeGreaterThanZero": "Muss größer als Null sein",
    "Rules_Validation_EmailMustBeValid": "E-Mail muss gültig sein",
    "Rules_Validation_MustBeLessThanMaxSafeInteger": "Größer als der zulässige Höchstwert",
    "Rules_Validation_MustBeLessThanLimit": "Muss kleiner sein als {}",
    "Rules_Validation_MustMatch": "Muss übereinstimmen",
    "Rules_Validation_MinLength": "Muss mindestens {} Zeichen lang sein",
    "Rules_Numbers_MaxSafeInteger": "den maximalen ganzzahligen Wert",
    "NAME": "RulesLanguage",
    "Rules_Validation_ValidUrl": "Muss eine gültige URL sein",
    "Rules_Validate_Empty": "Dieses Feld ist erforderlich",
    "Rules_Validation_MaxLength": "Darf höchstens {} Zeichen lang sein",
    "Rules_Validation_MaxWordLength": "Jedes Wort darf höchstens {} Zeichen lang sein",
    "Rules_Validation_IncorrectPattern": "Der angegebene Wert ist ungültig",
    "Rules_Validation_Unique": "Der Wert muss eindeutig sein",
    "Rules_Validation_ContentType": "Der Inhaltstyp muss einer der folgenden sein: {}"
}